var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "login-card" },
    [
      _c("svg-icon", {
        attrs: {
          "icon-class": !_vm.isQrLogin ? "wxicon" : "pcicon",
          "class-name": "angle-pic"
        },
        on: { click: _vm.loginTypeToggle }
      }),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.isQrLogin,
              expression: "!isQrLogin"
            }
          ],
          staticClass: "phone-login"
        },
        [
          _c("h2", [_vm._v("欢迎登录" + _vm._s(_vm.isYTS ? "云图梭" : ""))]),
          _c(
            "el-form",
            {
              ref: "loginForm",
              staticClass: "login-form",
              attrs: { model: _vm.loginForm, rules: _vm.rules },
              nativeOn: {
                submit: function($event) {
                  $event.preventDefault()
                }
              }
            },
            [
              _c(
                "div",
                { class: ["select-code", { "phone-active": _vm.phoneActive }] },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        "popper-append-to-body": false,
                        placeholder: "请选择"
                      },
                      on: {
                        change: function($event) {
                          _vm.loginForm.phone = ""
                        }
                      },
                      model: {
                        value: _vm.selectCode,
                        callback: function($$v) {
                          _vm.selectCode = $$v
                        },
                        expression: "selectCode"
                      }
                    },
                    _vm._l(_vm.areaCodeList, function(item) {
                      return _c(
                        "el-option",
                        {
                          key: item.countryCode,
                          attrs: { value: item.countryCode }
                        },
                        [
                          _c("span", { staticClass: "country" }, [
                            _vm._v(_vm._s(item.country))
                          ]),
                          _c("span", { staticStyle: { float: "right" } }, [
                            _vm._v(_vm._s(item.countryCode))
                          ])
                        ]
                      )
                    }),
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { prop: "phone" } },
                    [
                      _c("el-input", {
                        attrs: {
                          type: "text",
                          placeholder: "请输入手机号码",
                          autocomplete: "off",
                          maxlength: "11",
                          clearable: "",
                          spellcheck: "false"
                        },
                        on: {
                          focus: function($event) {
                            _vm.phoneActive = true
                          },
                          blur: function($event) {
                            _vm.phoneActive = false
                          }
                        },
                        model: {
                          value: _vm.loginForm.phone,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.loginForm,
                              "phone",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "loginForm.phone"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                { staticClass: "pic-code", attrs: { prop: "picNum" } },
                [
                  _c("el-input", {
                    class: [
                      "pic-num",
                      _vm.showCheckPic ? "pic-num2" : "",
                      _vm.picCodeWrong ? "pic-error" : ""
                    ],
                    attrs: {
                      type: "text",
                      placeholder: "输入验证码",
                      autocomplete: "off",
                      clearable: "",
                      spellcheck: "false"
                    },
                    on: {
                      input: _vm.changePicCode,
                      focus: function($event) {
                        _vm.pictureActive = true
                      },
                      blur: function($event) {
                        _vm.pictureActive = false
                      }
                    },
                    model: {
                      value: _vm.loginForm.picNum,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.loginForm,
                          "picNum",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "loginForm.picNum"
                    }
                  }),
                  _c("i", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.showCheckPic,
                        expression: "showCheckPic"
                      }
                    ],
                    staticClass: "el-icon-success"
                  }),
                  _c(
                    "div",
                    { staticClass: "img-con" },
                    [
                      _c(
                        "el-image",
                        {
                          staticClass: "yzpic",
                          staticStyle: { width: "60px", height: "30px" },
                          attrs: { src: _vm.picUrl }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "image-slot",
                              attrs: { slot: "placeholder" },
                              slot: "placeholder"
                            },
                            [_vm._v("加载中")]
                          )
                        ]
                      ),
                      _c(
                        "div",
                        {
                          staticClass: "refresh",
                          on: {
                            click: function($event) {
                              return _vm.getPicCodeAjax()
                            }
                          }
                        },
                        [_c("i", { staticClass: "el-icon-refresh-right" })]
                      )
                    ],
                    1
                  ),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.picCodeWrong,
                          expression: "picCodeWrong"
                        }
                      ],
                      staticClass: "imgcode-error"
                    },
                    [_vm._v("验证码错误")]
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                { staticClass: "yzcode", attrs: { prop: "code" } },
                [
                  _c("el-input", {
                    class: [
                      "validate-code",
                      { "validate-code2": _vm.sendAgain },
                      { "validate-code3": _vm.isCountdownIng }
                    ],
                    attrs: {
                      type: "text",
                      placeholder: "请输入短信验证码",
                      autocomplete: "off",
                      clearable: "",
                      maxlength: "6",
                      spellcheck: "false"
                    },
                    on: {
                      focus: function($event) {
                        _vm.codeActive = true
                      },
                      blur: function($event) {
                        _vm.codeActive = false
                      }
                    },
                    nativeOn: {
                      keyup: function($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        return _vm.confirm.apply(null, arguments)
                      }
                    },
                    model: {
                      value: _vm.loginForm.code,
                      callback: function($$v) {
                        _vm.$set(_vm.loginForm, "code", $$v)
                      },
                      expression: "loginForm.code"
                    }
                  }),
                  _c(
                    "el-button",
                    _vm._b(
                      {
                        staticClass: "send-btn",
                        staticStyle: { width: "15%" },
                        attrs: { disabled: _vm.loadingDisabled, type: "text" },
                        on: {
                          click: function($event) {
                            return _vm.sendMessageCode(false)
                          }
                        }
                      },
                      "el-button",
                      _vm._d({}, [_vm.attributeloading, _vm.eliconloading])
                    ),
                    [_vm._v(_vm._s(_vm.verificationText) + " ")]
                  )
                ],
                1
              ),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        _vm.selectCode === "+86" &&
                        _vm.count.phone &&
                        _vm.showCheckPic,
                      expression:
                        "selectCode==='+86' && count.phone && showCheckPic"
                    }
                  ],
                  class: ["code-voice", _vm.codeError ? "code-voice2" : ""]
                },
                [
                  _vm._v(" 无法接收短信验证码，获取 "),
                  _c(
                    "el-button",
                    {
                      attrs: { disabled: _vm.loadingDisabled, type: "text" },
                      on: { click: _vm.getPicMessageCode }
                    },
                    [_vm._v("语音验证码")]
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-button",
            {
              staticClass: "login-submit",
              attrs: { disabled: _vm.confirmDisabled, type: "primary" },
              on: { click: _vm.confirm }
            },
            [
              _c(
                "span",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.loginText !== "登录",
                      expression: "loginText !== '登录'"
                    }
                  ],
                  staticClass: "login-icon2"
                },
                [
                  _c("img", {
                    attrs: {
                      src: require("../../../assets/image/login/loading.svg"),
                      alt: ""
                    }
                  })
                ]
              ),
              _vm._v(" " + _vm._s(_vm.loginText) + " ")
            ]
          ),
          _c("div", { staticClass: "footer" }, [
            _vm.enablePasswordLogin
              ? _c("span", { on: { click: _vm.changeType } }, [
                  _vm._v("密码登录")
                ])
              : _c("span"),
            _vm._v(" "),
            _vm.isYTS
              ? _c("span", { on: { click: _vm.register } }, [
                  _vm._v("立即注册")
                ])
              : _c("span")
          ])
        ],
        1
      ),
      _vm.isQrLogin && !_vm.isGetUseInfo
        ? _c("div", { staticClass: "qr-login" }, [
            _vm._m(0),
            _c(
              "div",
              { class: ["qr-code-box", { "qr-err-box": _vm.qrCodeInvalid }] },
              [
                _c(
                  "div",
                  { staticClass: "qr-code" },
                  [
                    _c("vue-qr", { attrs: { text: _vm.qrCodeInfo, size: 190 } })
                  ],
                  1
                ),
                _vm.qrCodeInvalid
                  ? _c(
                      "div",
                      { staticClass: "qr-err", on: { click: _vm.refreshQr } },
                      [
                        _c("svg-icon", {
                          attrs: { "icon-class": _vm.errorIcon }
                        }),
                        _c("p", [_vm._v(_vm._s(_vm.qrInvalidMsg))]),
                        _c("p", [
                          _vm._v(
                            _vm._s(_vm.isOnline ? "刷新二维码" : "请检查网络")
                          )
                        ])
                      ],
                      1
                    )
                  : _vm._e()
              ]
            )
          ])
        : _vm._e(),
      _vm.isQrLogin && _vm.isGetUseInfo
        ? _c("div", { staticClass: "qr-login" }, [
            _vm._m(1),
            _c("div", { staticClass: "qr-content" }, [
              _c(
                "div",
                { class: ["qr-code-box", { "qr-err-box": _vm.qrCodeInvalid }] },
                [
                  _c(
                    "div",
                    { staticClass: "qr-code new-qrcode" },
                    [
                      _c("vue-qr", {
                        attrs: { text: _vm.qrCodeInfo, size: 120, margin: 8 }
                      })
                    ],
                    1
                  ),
                  _vm.qrCodeInvalid
                    ? _c(
                        "div",
                        { staticClass: "qr-err", on: { click: _vm.refreshQr } },
                        [
                          _c("svg-icon", {
                            attrs: { "icon-class": _vm.errorIcon }
                          }),
                          _c("p", [_vm._v(_vm._s(_vm.qrInvalidMsg))]),
                          _c("p", [
                            _vm._v(
                              _vm._s(_vm.isOnline ? "刷新二维码" : "请检查网络")
                            )
                          ])
                        ],
                        1
                      )
                    : _vm._e()
                ]
              ),
              _c(
                "div",
                { staticClass: "head-img", on: { click: _vm.onUserLogin } },
                [
                  _vm.headImg
                    ? _c("img", {
                        staticClass: "head-bg",
                        attrs: { src: _vm.headImg }
                      })
                    : _c("img", {
                        staticClass: "head-bg",
                        attrs: {
                          src: require("../../../assets/image/login/default-head.png")
                        }
                      }),
                  _c("div", { staticClass: "name" }, [
                    _vm._v(_vm._s(_vm.realName))
                  ])
                ]
              )
            ])
          ])
        : _vm._e(),
      _c("p", { staticClass: "footer-tip" }, [
        _vm._v("登录即表示同意"),
        _c("span", { on: { click: _vm.showProtocol } }, [_vm._v("用户协议")]),
        _vm._v("和"),
        _c("span", { on: { click: _vm.showPrivacy } }, [_vm._v("隐私政策")])
      ])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("header", [
      _c("h2", [_vm._v("扫码登录")]),
      _c("p", [_vm._v("请使用云图梭移动端扫描二维码")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("header", [
      _c("h2", [_vm._v("快速登录")]),
      _c("p", { staticClass: "new-qr-text" }, [
        _vm._v("请使用云图梭移动端扫码二维码")
      ]),
      _c("p", { staticClass: "new-qr-text" }, [_vm._v("或点击头像授权登录")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }